import { render, staticRenderFns } from "./new-product.vue?vue&type=template&id=2f80e4b6"
import script from "./new-product.vue?vue&type=script&lang=js"
export * from "./new-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports